import React, { useState, useEffect } from "react";
import cogoToast from "cogo-toast";


import { Helmet } from "react-helmet";
import Header from "../components/header/header";
import SidebarOperacion from "../components/header/sidebarOperacion";
import CommonAreaTable from "../components/commonAreas/commonTable";
import Controls from "../components/controls/controls";
import DinamicModal from "../components/dinamicModal/dinamicModal";
import Paginador from "../components/paginador/paginador";
import Request from "../core/httpClient";
import Permissions from "../middlewares/Permissions";

import sortableData from '../helpers/sortableDataTable';
import { Consumer } from "../context";
import { useCallback } from "react";
import CommonAreasCreate from "../components/commonAreas/CommonAreasCreate";

const request = new Request();
const CommonAreas = ({ context }) => {
	const [showModal, setShowModal] = useState(false);
	const [commonAreas, setCommonAreas] = useState([]);
	const [categories, setCategories] = useState([]);
	const [categoria, setCategoria] = useState(0);
	const [filterData, setFilterData] = useState([]);
	const [keys, setKeys] = useState([]);
	const [page, setPage] = useState(1);
	const [filter, setFilter] = useState("");
	const [subfraccionamiento, setSubfraccionamiento] = useState(localStorage.getItem("subfrac") || 0);
	const [subfraccionamientos, setSubfraccionamientos] = useState([]);
	const [imageArea, setImageArea] = useState("");
	const [idSubfrac, setIdSubfrac] = useState(localStorage.getItem("subfrac") || 0);
	const [escritura, setEscritura] = useState(false);
	const [lectura, setLectura] = useState(false);
	const [menu, setMenu] = useState(null);
	const [logo] = useState(require("../img/logo-AppMosphera-r.png"));
	const [anuales, setAnuales] = useState(0);
	const [mensuales, setMensuales] = useState(0);
	const [diarias, setDiarias] = useState(0);
	const [consecutivas, setConsecutivas] = useState(0);
	const [pageLength, setPageLength] = useState(20);
	const [direction, setDirection] = useState({});
	const [filterColumn, setFilterColumn] = useState({});
	const [aforoMax, setAforoMax] = useState(false);
	const [name, setName] = useState("");
	const [diasPrevios, setDiasPrevios] = useState(0);
	const [minutosPrevios, setMinutosPrevios] = useState(0);
	const [isDiasDisponible, setIsDiasDisponible] = useState(true);
	const [tiempoDisponible, setTiempoDisponible] = useState(0);
	const [deposito, setDeposito] = useState(0);
	const [descripcion, setDescripcion] = useState("");
	const [motivo, setMotivo] = useState("");
	const [pausar, setPausar] = useState(false);
	const [submenu, setSubmenu] = useState("");
	const [maXVivienda, setMaXVivienda] = useState(1);
	const [subLabel, setSubLabel] = useState("");
	const [aforo, setAforo] = useState(1);
	const [loadingSave, setLoadingSave] = useState(false);
	const [activo, setActivo] = useState(false);

	const state = {
		nombre: name,
		descripcion,
		activo,
		categoria,
		diasPrevios,
		minutosPrevios,
		fianza: deposito,
		tiempoDisponible,
		isDiasDisponible,
		imagenArea: imageArea,
		idSubfrac,
		subfraccionamientos,
		categories,
		anuales,
		mensuales,
		diarias,
		consecutivas,
		aforo,
		aforoMax,
		maXVivienda,
		pausar,
		motivo,
		subLabel,
	};



	const getCommonAreas = useCallback(async () => {
		try {
			setLoading(true);

			const idSub = subfraccionamiento;

			const data = {
				IdFraccionamiento: parseInt(localStorage.getItem("frac")),
				idSub: idSub,
			};

			const response = await request.post("/commonArea/get/areas", data);

			if (response.commonAreas) {
				const parsedAreas = response.commonAreas.map((row) => {
					if (row.bloqueos !== null) {
						row.bloqueos = JSON.parse(row.bloqueos);
					}
					return row;
				});

				setCommonAreas(parsedAreas);
			} else {
				setMessage("");
			}

			setLoading(false);
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	}, [subfraccionamiento]); // dependencias internas


	// componentDidMount 
	useEffect(() => {
		const init = async () => {
			await validarPermisos();
			await getSubmenu();
			await getCommonAreas();
			await getCategories();
			await getSubFraccionamientos();
		};
		init();
	}, []);

	// componentDidUpdate equivalente para subfraccionamiento
	useEffect(() => {
		getCommonAreas();
	}, [getCommonAreas]);


	const validarPermisos = async () => {
		let permisos = new Permissions();
		let permisosInfo = await permisos.getResult();
		setEscritura(permisosInfo.escritura);
		setLectura(permisosInfo.lectura);
	};

	const getSubmenu = async () => {
		// Verifica que context exista y tenga la función
		if (context && typeof context.getSubmenuOpeName === "function") {
			const submenuRes = await context.getSubmenuOpeName();
			if (submenuRes) {
				setSubmenu(submenuRes);
			}
		}

		const subLabelRes = window.localStorage.getItem("subLabel");
		if (subLabelRes) {
			setSubLabel(subLabelRes);
		}
	};


	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");




	const getCategories = async () => {
		try {
			const data = { id: localStorage.getItem("frac") };
			const response = await request.post("/commonArea/get/categories", data);
			if (response && !response.error && response.categories && !response.empty) {
				setCategories(response.categories);
				if (response.categories.length !== 0) {
					setCategoria(response.categories[0].id_categoria);
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getSubFraccionamientos = async () => {
		try {
			const fraccionamiento = localStorage.getItem("frac");
			if (!fraccionamiento) return;
			const data = { Idsub: fraccionamiento, filter: 1 };
			const response = await request.post("/admin/administracion/get/subfraccionamientos", data);
			if (response && !response.error && response.subfraccionamiento && !response.empty) {
				setSubfraccionamientos(response.subfraccionamiento);
				setFilterData(response.subfraccionamiento);
			} else {
				setSubfraccionamientos([]);
			}
		} catch (error) {
			console.log(error);
		}
	};


	const openModal = () => {
		// reset de estados
		setMessage(null);
		setImageArea("");
		setName("");
		setDiasPrevios(0);
		setMinutosPrevios(0);
		setIsDiasDisponible(true);
		setTiempoDisponible(0);
		setDeposito(0);
		setDescripcion("");
		setAforo(1);
		setAnuales(0);
		setMensuales(0);
		setDiarias(0);
		setConsecutivas(0);
		setMotivo("");
		setPausar(false);
		setMaXVivienda(1);
		setAforoMax(false);
		setActivo(false);

		// abrir modal por id
		const modal = document.getElementById("newCommonArea");
		if (modal) {
			modal.classList.remove("hide-dinamic-modal");
			modal.classList.add("show-dinamic-modal");
		}

		// enfocar input
		const areaname = document.getElementById("areaname");
		if (areaname) {
			areaname.focus();
		}
	};



	const closeModal = () => {
		// reset de estados
		setName("");
		setDiasPrevios(0);
		setMinutosPrevios(0);
		setIsDiasDisponible(true);
		setTiempoDisponible(0);
		setDeposito(0);
		setDescripcion("");
		setAnuales(0);
		setMensuales(0);
		setDiarias(0);
		setConsecutivas(0);
		setMotivo("");
		setPausar(false);
		setMaXVivienda(1);
		setAforoMax(false);
		setActivo(false);

		// cerrar modal por id
		const modal = document.getElementById("newCommonArea");
		if (modal) {
			modal.classList.remove("show-dinamic-modal");
			modal.classList.add("hide-dinamic-modal");
		}
	};


	// paginatorChange
	const paginatorChange = (length) => {
		setPageLength(length);
		setPage(1);
	};

	// reload
	const reload = async () => {
		await getCommonAreas();
	};

	// changeFrac
	const changeFrac = async () => {
		await getCommonAreas();
	};

	// subChange
	const subChange = (sub) => {
		setSubfraccionamiento(sub);
	};

	// setFilter
	const updateFilter = (filterValue) => {
		setFilter(filterValue.toLowerCase());
	};

	// filter
	const filterAreas = (areas) => {
		return areas.filter((com) => {
			if (com.descripcion.toLowerCase().includes(filter)) {
				return true;
			} else if (com.nombre.toLowerCase().includes(filter)) {
				return true;
			} else {
				return false;
			}
		});
	};

	// sortableTable
	const sortableTable = (key) => {
		let sd = new sortableData();
		const { items, direction: dir } = sd.sortBy(key, commonAreas, direction[key]);

		setCommonAreas(items);
		setDirection({ [key]: dir });
		setFilterColumn({ col: key, filt: dir });
	};

	// Ejemplo de función adaptada
	const handleSubmit = async (event) => {
		event.preventDefault();

		try {
			setLoadingSave(true);

			if (name === "") {
				cogoToast.warn("Es necesario añadir nombre antes de guardar.", { position: "bottom-right" });
				setLoadingSave(false);
				return;
			}

			if (aforoMax && maXVivienda > aforo) {
				cogoToast.warn("El número máximo por vivienda no puede ser mayor al número de aforo máximo.", { position: "bottom-right" });
				setLoadingSave(false);
				return;
			}

			let image = imageArea ? imageArea : "";

			const data = {
				IdFraccionamiento: parseInt(localStorage.getItem("frac")),
				idSubfrac: parseInt(idSubfrac),
				nombre: name,
				descripcion: descripcion !== "" ? descripcion : "Sin descripción",
				Categoria: parseInt(categoria),
				diasReserva: parseInt(diasPrevios),
				minutosPrevios: parseInt(minutosPrevios),
				Activo: activo ? 1 : 0,
				fianza: parseInt(deposito),
				diasMaximos: isDiasDisponible ? parseInt(tiempoDisponible) : null,
				horasMaximas: isDiasDisponible ? null : parseInt(tiempoDisponible),
				imagen: image,
				anuales: parseInt(anuales),
				mensuales: parseInt(mensuales),
				diarias: parseInt(diarias),
				consecutivas: parseInt(consecutivas),
				aforo: aforoMax ? parseInt(aforo) : null,
				reservasAforoMax: aforoMax ? parseInt(maXVivienda) : null,
				pausar: pausar ? 1 : 0,
				motivo: motivo,
			};

			const response = await request.post("/commonArea/create/new", data);

			if (response.created) {
				setShowModal(false);
				setImageArea("");
				setAnuales(0);
				setMensuales(0);
				setDiarias(0);
				setConsecutivas(0);

				await getCommonAreas();
				closeModal("newCommonArea");

				cogoToast.success("Área común agregada.", { position: "bottom-right" });
			} else {
				cogoToast.error("No se pudo agregar área común.", { position: "bottom-right" });
			}

			setLoadingSave(false);
		} catch (error) {
			console.log(error);
		}
	};



	// Función para mostrar preview
	const showPreviewImageCommonArea = (event) => {
		const file = event.target.files[0];
		if (file) {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onloadend = () => {
				setImageArea(reader.result);
			};
		}
	};


	const [activeTab, setActiveTab] = useState("basicos");

	const renderNewCommonArea = () => (
		<div className="w-full">
			{/* Tabs header */}
			<ul className="flex border-b text-sm font-medium">
				<li className="mr-2">
					<button
						type="button"
						onClick={() => setActiveTab("basicos")}
						className={`inline-block px-4 py-2 rounded-t-md ${activeTab === "basicos"
							? "bg-gray-200 text-purple-950 border border-b-0 border-gray-300"
							: "text-gray-600 hover:bg-gray-100"
							}`}
					>
						Datos básicos
					</button>
				</li>
				<li className="mr-2">
					<button
						type="button"
						onClick={() => setActiveTab("reservas")}
						className={`inline-block px-4 py-2 rounded-t-md ${activeTab === "reservas"
							? "bg-gray-200 text-purple-950 border border-b-0 border-gray-300"
							: "text-gray-600 hover:bg-gray-100"
							}`}
					>
						Reservas
					</button>
				</li>
				<li className="mr-2">
					<button
						type="button"
						onClick={() => setActiveTab("aforo")}
						className={`inline-block px-4 py-2 rounded-t-md ${activeTab === "aforo"
							? "bg-gray-200 text-purple-950 border border-b-0 border-gray-300"
							: "text-gray-600 hover:bg-gray-100"
							}`}
					>
						Aforo
					</button>
				</li>
				<li>
					<button
						type="button"
						onClick={() => setActiveTab("politicas")}
						className={`inline-block px-4 py-2 rounded-t-md ${activeTab === "politicas"
							? "bg-gray-200 text-purple-950 border border-b-0 border-gray-300"
							: "text-gray-600 hover:bg-gray-100"
							}`}
					>
						Políticas
					</button>
				</li>
			</ul>



			{/* Tab content */}
			{activeTab === "basicos" && (
				<div className="grid grid-cols-2 gap-6">
					{/* Nombre */}
					<div>
						<label className="block text-sm font-semibold mb-1">Nombre</label>
						<input
							type="text"
							id="areaname"
							className="input-user"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
					</div>

					{/* Subfraccionamiento */}
					<div>
						<label className="block text-sm font-semibold mb-1">Subfraccionamiento</label>
						<select
							className="input-user"
							value={idSubfrac}
							onChange={(e) => setIdSubfrac(e.target.value)}
						>
							<option value="0">TODOS</option>
							{subfraccionamientos.map((sub) => (
								<option key={sub.id_subfraccionamiento} value={sub.id_subfraccionamiento}>
									{sub.nombre}
								</option>
							))}
						</select>
					</div>

					{/* Categoría */}
					<div>
						<label className="block text-sm font-semibold mb-1">Categoría</label>
						<select
							className="input-user"
							value={categoria}
							onChange={(e) => setCategoria(e.target.value)}
						>
							{categories.map((cat) => (
								<option key={cat.id_categoria} value={cat.id_categoria}>
									{cat.nombre}
								</option>
							))}
						</select>
					</div>

					{/* Depósito */}
					<div>
						<label className="block text-sm font-semibold mb-1">Depósito</label>
						<input
							type="number"
							min="0"
							className="input-edit-select-full"
							value={deposito}
							onChange={(e) => setDeposito(e.target.value)}
						/>
					</div>

					{/* Subir imagen + preview en una fila */}
					<div className="col-span-2">
						<div className="flex items-center space-x-6">
							{/* Botón subir imagen */}
							<label className="cursor-pointer flex flex-col items-center justify-center text-gray-600 border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
								<i className="fas fa-file-upload text-2xl mb-2"></i>
								<input
									type="file"
									id="fileImage"
									name="AreaImage"
									accept="image/*"
									onChange={showPreviewImageCommonArea}
									className="hidden"
								/>
								<p className="text-sm font-medium">Subir imagen</p>
							</label>

							{/* Preview de la imagen */}
							<div>
								<img
									src={imageArea ? imageArea : require("../img/empty_image.png")}
									alt="Preview área común"
									className="w-48 h-48 object-cover rounded border"
								/>
							</div>
						</div>
					</div>


				</div>
			)}

			{activeTab === "reservas" && (
				<div className="space-y-6">
					{/* Configuración previa */}
					<div className="grid grid-cols-2 gap-6">
						{/* Días previos */}
						<div>
							<label className="block text-sm font-semibold mb-1">Días previos</label>
							<input
								type="number"
								min="0"
								className="input-edit-select-full"
								value={diasPrevios}
								onChange={(e) => setDiasPrevios(e.target.value)}
							/>
						</div>

						{/* Minutos previos */}
						<div>
							<label className="block text-sm font-semibold mb-1">Minutos previos</label>
							<input
								type="number"
								min="0"
								className="input-edit-select-full"
								value={minutosPrevios}
								onChange={(e) => setMinutosPrevios(e.target.value)}
							/>
						</div>
					</div>

					{/* Disponibilidad */}
					<div>
						<label className="block text-sm font-semibold mb-1">Disponibilidad</label>
						<div className="flex items-center space-x-6 mb-2">
							<label className="flex items-center space-x-2">
								<input
									type="radio"
									checked={isDiasDisponible}
									onChange={() => setIsDiasDisponible(true)}
									className="h-4 w-4 text-blue-600 border-gray-300"
								/>
								<span>Días disponibles</span>
							</label>
							<label className="flex items-center space-x-2">
								<input
									type="radio"
									checked={!isDiasDisponible}
									onChange={() => setIsDiasDisponible(false)}
									className="h-4 w-4 text-blue-600 border-gray-300"
								/>
								<span>Horas disponibles</span>
							</label>
						</div>
						<input
							type="number"
							min="0"
							className="input-edit-select-full"
							value={tiempoDisponible}
							onChange={(e) => setTiempoDisponible(e.target.value)}
						/>
					</div>

					{/* Límites de reservas */}
					<div className="grid grid-cols-2 gap-6">
						<div>
							<label className="block text-sm font-semibold mb-1">Reservas anuales</label>
							<input
								type="number"
								min="0"
								className="input-edit-select-full"
								value={anuales}
								onChange={(e) => setAnuales(e.target.value)}
							/>
						</div>

						<div>
							<label className="block text-sm font-semibold mb-1">Reservas mensuales</label>
							<input
								type="number"
								min="0"
								className="input-edit-select-full"
								value={mensuales}
								onChange={(e) => setMensuales(e.target.value)}
							/>
						</div>

						<div>
							<label className="block text-sm font-semibold mb-1">Reservas diarias</label>
							<input
								type="number"
								min="0"
								className="input-edit-select-full"
								value={diarias}
								onChange={(e) => setDiarias(e.target.value)}
							/>
						</div>

						<div>
							<label className="block text-sm font-semibold mb-1">Reservas abiertas</label>
							<input
								type="number"
								min="0"
								className="input-edit-select-full"
								value={consecutivas}
								onChange={(e) => setConsecutivas(e.target.value)}
							/>
						</div>
					</div>
				</div>
			)}


			{activeTab === "aforo" && (
				<div className="space-y-6">
					{/* Activar aforo */}
					<div className="flex items-center space-x-2">
						<input
							type="checkbox"
							id="aforoMax"
							checked={aforoMax}
							onChange={(e) => {
								setAforoMax(e.target.checked);
								setAforo(1);
								setMaXVivienda(1);
							}}
							className="h-4 w-4 text-blue-600 border-gray-300 rounded"
						/>
						<label htmlFor="aforoMax" className="text-sm font-medium">
							Activar aforo
						</label>
					</div>

					{/* Campos visibles solo si está activo */}
					{aforoMax && (
						<div className="grid grid-cols-2 gap-6">
							{/* Aforo máximo */}
							<div>
								<label className="block text-sm font-semibold mb-1">
									Aforo máximo (Viviendas simultáneas)
								</label>
								<input
									type="number"
									min="1"
									value={aforo}
									onChange={(e) => setAforo(parseInt(e.target.value))}
									className="input-edit-select-full"
								/>
							</div>

							{/* Máximo por vivienda */}
							<div>
								<label className="block text-sm font-semibold mb-1">
									Máximo por vivienda
								</label>
								<input
									type="number"
									min="1"
									value={maXVivienda}
									onChange={(e) => setMaXVivienda(parseInt(e.target.value))}
									className="input-edit-select-full"
								/>
							</div>
						</div>
					)}
				</div>
			)}


			{activeTab === "politicas" && (
				<div className="space-y-6">
					{/* Políticas de uso */}
					<div>
						<label className="block text-sm font-semibold mb-1">Políticas de uso</label>
						<textarea
							name="descripcion"
							rows="4"
							value={descripcion}
							onChange={(e) => setDescripcion(e.target.value)}
							className="input-user"
							autoComplete="off"
						></textarea>
					</div>

					{/* Pausar reservas + motivo */}
					<div className="space-y-3">
						<div className="flex items-center space-x-2">
							<input
								type="checkbox"
								id="pausar"
								checked={pausar}
								onChange={(e) => setPausar(e.target.checked)}
								className="h-4 w-4 text-blue-600 border-gray-300 rounded"
							/>
							<label
								htmlFor="pausar"
								className="text-sm font-medium inline-flex items-center"
							>
								Pausar reservas
							</label>
						</div>

						{pausar && (
							<div className="mt-8">
								<label className="block text-sm font-semibold mb-1 mt-4">Motivo</label>
								<textarea
									name="motivo"
									rows="3"
									value={motivo}
									onChange={(e) => setMotivo(e.target.value)}
									className="input-user"
									autoComplete="off"
								></textarea>
							</div>
						)}
					</div>

					{/* Activar área común con línea */}
					<div className="border-t pt-4 flex items-center space-x-2">
						<input
							type="checkbox"
							id="activar"
							checked={activo}
							onChange={(e) => setActivo(e.target.checked)}
							className="h-4 w-4 text-blue-600 border-gray-300 rounded"
						/>
						<label
							htmlFor="activar"
							className="text-sm font-medium whitespace-nowrap"
						>
							Activar área común
						</label>
					</div>

				</div>
			)}


		</div>
	);

	const handleUpdate = (updates) => {
		if (updates.nombre !== undefined) setName(updates.nombre);
		if (updates.descripcion !== undefined) setDescripcion(updates.descripcion);
		if (updates.activo !== undefined) setActivo(updates.activo);
		if (updates.categoria !== undefined) setCategoria(updates.categoria);
		if (updates.diasPrevios !== undefined) setDiasPrevios(updates.diasPrevios);
		if (updates.minutosPrevios !== undefined) setMinutosPrevios(updates.minutosPrevios);
		if (updates.fianza !== undefined) setDeposito(updates.fianza);
		if (updates.tiempoDisponible !== undefined) setTiempoDisponible(updates.tiempoDisponible);
		if (updates.isDiasDisponible !== undefined) setIsDiasDisponible(updates.isDiasDisponible);
		if (updates.imagenArea !== undefined) setImageArea(updates.imagenArea);
		if (updates.idSubfrac !== undefined) setIdSubfrac(updates.idSubfrac);
		if (updates.anuales !== undefined) setAnuales(updates.anuales);
		if (updates.mensuales !== undefined) setMensuales(updates.mensuales);
		if (updates.diarias !== undefined) setDiarias(updates.diarias);
		if (updates.consecutivas !== undefined) setConsecutivas(updates.consecutivas);
		if (updates.aforo !== undefined) setAforo(updates.aforo);
		if (updates.aforoMax !== undefined) setAforoMax(updates.aforoMax);
		if (updates.maXVivienda !== undefined) setMaXVivienda(updates.maXVivienda);
		if (updates.pausar !== undefined) setPausar(updates.pausar);
		if (updates.motivo !== undefined) setMotivo(updates.motivo);
	};

	return (
		<div className="admin column">
			<Helmet>
				<title>{process.env.REACT_APP_NAME} - {submenu}</title>
			</Helmet>

			<Header
				reload={reload}
				change={changeFrac}
				sidebar={true}
				active="activas"
				parent="areas"
				panel="panel3"
				nav="operacion"
				menu={menu}
			/>

			<div className="row">
				<div className="column" id="sidebar">
					<SidebarOperacion />
				</div>
				<div className="column" id="content">
					<div className="justify-center">
						<div className="container column">
							{lectura && (
								<>
									<Controls
										title={submenu}
										nuevo={openModal}
										dataSet={filterAreas(commonAreas)}
										setFilter={updateFilter}
										subChange={subChange}
										newButton={escritura}
									/>

									{loading ? (
										<div className="row justify-center">
											<i className="fas fa-spinner fa-spin"></i>
										</div>
									) : (
										<CommonAreaTable
											commonAreas={filterAreas(commonAreas)}
											subfraccionamientos={subfraccionamientos}
											page={page}
											reload={reload}
											escritura={escritura}
											pageLength={pageLength}
											sortBy={sortableTable}
											filterColumn={filterColumn}
											subLabel={subLabel}
											getCommonAreas={getCommonAreas}
										/>
									)}

									<div className="white-space-16"></div>

									<Paginador
										pages={Math.ceil(filterAreas(commonAreas).length / pageLength)}
										setPage={setPage}
										pageLength={pageLength}
										paginatorChange={paginatorChange}
										showPageLenght={true}
									/>
								</>
							)}
						</div>
					</div>
				</div>
			</div>

			<DinamicModal
				idModal="newCommonArea"
				sizeModalContainer="big"
				title="Añadir área común"
				success={handleSubmit}          // tu función de creación
				showBtnSuccess={true}
				btnTextSuccess="GUARDAR"
				showBtnCancel={true}
				btnTextCancel="CANCELAR"
				loadingSave={loadingSave}
				message={message}
				closeModal={closeModal}
				showModal={showModal}
			>
				<CommonAreasCreate
					state={state}
					handleUpdate={handleUpdate}
					showPreviewImageCommon={showPreviewImageCommonArea}
					onSubmit={handleSubmit}
				/>
			</DinamicModal>

		</div>
	);


};

export default CommonAreas;
